/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import "./audio-pulse.scss";
import c from "classnames";

const lineCount = 3;

export type AudioPulseProps = {
  hover?: boolean;
};

export default function AudioPulse({ hover }: AudioPulseProps) {
  return (
    <div id="audio-pulse" className={c("audioPulse", { active: true, hover })}>
      {Array(lineCount)
        .fill(null)
        .map((_, i) => (
          <div
            id={"ta-sdk-audioLine-" + i}
            key={i}
            style={{ animationDelay: `${i * 133}ms` }}
          />
        ))}
    </div>
  );
}
